import React from 'react';
import {Button, Form, InputGroup, Modal} from "react-bootstrap";
import {XLg} from "react-bootstrap-icons";
import DraggableModal from '../DraggableModal';

/**
 * Модальное окно выбора элементов
 * @param handleClose
 * @param title
 * @param filteredResults
 * @param searchInput
 * @param searchItems
 * @param isChecked
 * @param options Массив вариантов: {key (значение, обязательно), text (текстовое наименование, обязательно), label (JSX, для более сложного отображения, необязательно), readonly (необязательно)}
 * @param handleCheck
 * @param required
 * @param show
 * @param clearValue
 * @returns {JSX.Element}
 * @constructor
 */
const ModalSelection = ({handleClose,title,filteredResults,searchInput,searchItems,isChecked,options,handleCheck,required,show,clearValue}) => {
    return (
        <DraggableModal size="lg" show={show} headerNode={title} onHide={handleClose} >
            <Modal.Body>
                <InputGroup style={{ marginTop: 8, marginBottom: 16 }}>
                    <Form.Control type="text" placeholder="Поиск..." value={searchInput} onChange={(e) => searchItems(e.target.value)} />
                    <Button variant="outline-secondary" onClick={clearValue}><XLg className="mb-1" /></Button>
                </InputGroup>
                <Form>
                    {searchInput.length > 1 ? (
                        filteredResults.map((item, index) => (
                            <Form.Group key={item.key} className={index < options.length - 1 ? 'mb-1' : ''} controlId={item.key + (item?.text ?? '')}>
                                <Form.Check
                                    disabled={options.filter((e) => isChecked(e)).length <= 1 && isChecked(item) && required || item.readonly}
                                    checked={isChecked(item)}
                                    onChange={() => handleCheck(item.key)}
                                    type="checkbox"
                                    label={item?.label ?? item?.text ?? ''}
                                />
                            </Form.Group>
                        ))
                    ) : (
                        options.map((item, index) => (
                            <Form.Group key={item.key} className={index < options.length - 1 ? 'mb-1' : ''} controlId={item.key + (item?.text ?? '')}>
                                <Form.Check
                                    disabled={options.filter((e) => isChecked(e)).length <= 1 && isChecked(item) && required || item.readonly}
                                    checked={isChecked(item)}
                                    onChange={() => handleCheck(item.key)}
                                    type="checkbox"
                                    label={item?.label ?? item?.text ?? ''}
                                />
                            </Form.Group>
                        ))
                    )}
                </Form>
            </Modal.Body>
        </DraggableModal>
    );
};

export default ModalSelection;
